// extracted by mini-css-extract-plugin
export default {"main_card":"ProductCard_main_card__oQXw9","card_action":"ProductCard_card_action__J5fBN","cart_box":"ProductCard_cart_box__lb5tM","cart_img":"ProductCard_cart_img__o+xC1"};